import { combineReducers } from 'redux'

import * as appActions from './app/actions'
import appReducer from './app/reducer'
import component from './component'
import user from './user'
import view from './view'

export const Actions = {
  app: appActions,
  user: user.Actions,
  view: view.Actions,
  component: component.Actions,
}

export const RootReducer = combineReducers({
  app: appReducer,
  user: user.Reducer,
  view: view.Reducer,
  component: component.Reducer,
})
